import { createFileRoute } from '@tanstack/react-router'
import { ToolsIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/strumenti/')({
  loader: () => loadPageData({ data: { kind: 'tools', locale: 'it' } }),
  head: () => staticRouteHead('tools', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ToolsIndexPage />
    </CatalogProvider>
  )
}
